import { HttpClient } from "@angular/common/http";
import { Inject, Injectable, OnDestroy } from "@angular/core";
import * as signalR from "@microsoft/signalr";
import { HubConnection, Subject } from "@microsoft/signalr";
import { ENVIRONMENT_CONFIG } from "../../config/environment.config.token";
import { CallTicketMessage, NotificationMessage, RegisterPatientMessage } from "../../models/notification";
import { AuthService } from "../auth.service";
import { BehaviorSubject } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class NotificationSignalRService implements OnDestroy {
    private readonly _baseUrl: string;
    private hubConnection: HubConnection;
    messages: Subject<NotificationMessage> = new Subject();
    queueMessages: Subject<NotificationMessage> = new Subject();
    callTicket: Subject<CallTicketMessage> = new Subject();
    registerPatient: BehaviorSubject<RegisterPatientMessage> = new BehaviorSubject(null);

    constructor(private http: HttpClient, private authService: AuthService, @Inject(ENVIRONMENT_CONFIG) environment) {
        this._baseUrl = environment.env.notificationUrl;
    }
    ngOnDestroy(): void {
        this.hubConnection.stop();
        this.hubConnection = null;
    }

    init() {
        let options = {
            accessTokenFactory: () => this.authService.getAccessToken(),
            transport: signalR.HttpTransportType.LongPolling
        };

        this.hubConnection = new signalR.HubConnectionBuilder()
            .withUrl(`${this._baseUrl}/hub/notification`, options)
            .withAutomaticReconnect([1000, 1000, 1000, 1000])
            .build();

        this.hubConnection.start().then((success) => {
            console.log('SignalR Connected');
        }, (reject) => {
            console.log('SignalR Reject Error');
        })
            .catch((err) => {
                console.log('SignalR Connect Error');
            });

        this.hubConnection.on("ReceiveNotification", (data: NotificationMessage) => {
            this.messages.next(data);
        });
        this.hubConnection.on("QueueNotification", (data: NotificationMessage) => {
            this.queueMessages.next(data);
        });
        this.hubConnection.on("CallTicket", (data: CallTicketMessage) => {
            this.callTicket.next(data);
        });
        this.hubConnection.on("RegisterPatient", (data: RegisterPatientMessage) => {
            this.registerPatient.next(data);
        });

    }

    // private getConnectionInfo(): Observable<SignalRConnectionInfo> {
    //     let requestUrl = `${this._baseUrl}/hub/notification/negotiate?negotiateVersion=1`;
    //     return this.http.get<SignalRConnectionInfo>(requestUrl);
    // }

    // init() {
    //     this.getConnectionInfo().subscribe((info) => {
    //         let options = {
    //             accessTokenFactory: () => info.accessToken,
    //             transport: signalR.HttpTransportType.LongPolling
    //         };

    //         let requestUrl = `${this._baseUrl}/hub/notification`;
    //         this.hubConnection = new signalR.HubConnectionBuilder()
    //             .withUrl(requestUrl, options)
    //             .configureLogging(signalR.LogLevel.Information)
    //             .withAutomaticReconnect([1000, 2000, 2000, 2000])
    //             .build();

    //         this.hubConnection.start().catch((err) => console.error(err.toString()));

    //         this.hubConnection.on("ReceiveNotification", (data: NotificationMessage) => {
    //             this.messages.next(data);
    //         });
    //     });
    // }
}